module.exports = __webpack_public_path__ + "static/media/tutorial1.3276ce6b.mp4";